// Zona 4 — Panel de contexto V3 (resumen del residente / sitio, notas, cobertura del sensor).
import { UserRound, StickyNote, ShieldCheck, Building2, MapPin } from "lucide-react";
import { esTecnica } from "@/lib/consolaV3/meta";
import { calcEdad } from "@/lib/format";

function Card({ icon: Icon, title, children, testId }) {
  return (
    <section data-testid={testId} className="rounded-xl border border-slate-200 bg-white dark:bg-[#14243A] p-3.5">
      <h4 className="mb-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-[#012472] dark:text-[#80B3FF]"><Icon className="h-3.5 w-3.5" /> {title}</h4>
      {children}
    </section>
  );
}

export default function ContextPanelV3({ detail }) {
  if (!detail) {
    return (
      <div data-testid="v3-context-vacio" className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center">
        <Building2 className="h-7 w-7 text-slate-300 dark:text-slate-600" />
        <p className="text-sm text-slate-400 dark:text-slate-500">Selecciona un caso para ver el contexto del residente.</p>
      </div>
    );
  }
  const a = detail;
  const tec = esTecnica(a);
  const p = a.persona || {};
  const edad = calcEdad(p.fecha_nacimiento);
  const sitio = a.sitio || {};

  return (
    <div className="flex h-full flex-col gap-3 overflow-y-auto p-3" data-testid="v3-context-panel">
      {tec ? (
        <Card icon={Building2} title="Sitio" testId="v3-ctx-sitio">
          <p className="text-sm font-semibold text-slate-800 dark:text-slate-100">{a.sitio_nombre || sitio.nombre}</p>
          {sitio.direccion && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{[sitio.direccion, sitio.ciudad].filter(Boolean).join(", ")}</p>}
          <p className="mt-2 text-xs text-slate-400">Incidencia de infraestructura. No hay persona asociada a este caso.</p>
        </Card>
      ) : (
        <>
          <Card icon={UserRound} title="Residente" testId="v3-ctx-residente">
            <p className="text-base font-bold text-slate-800 dark:text-slate-100">{p.nombre_completo || a.persona_nombre || "—"}{edad != null && <span className="text-sm font-normal text-slate-500 dark:text-slate-400"> · {edad} años</span>}</p>
            {p.condiciones && <p className="mt-1.5 text-sm text-slate-600 dark:text-slate-300">{p.condiciones}</p>}
            <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">{a.sitio_nombre || sitio.nombre}{a.zona_nombre ? ` · ${a.zona_nombre}` : ""}</p>
          </Card>
          {p.notas_operativas && (
            <Card icon={StickyNote} title="Notas operativas de cuidado" testId="v3-ctx-notas">
              <p className="text-sm text-slate-600 dark:text-slate-300 whitespace-pre-wrap">{p.notas_operativas}</p>
            </Card>
          )}
          {(sitio.direccion || sitio.ciudad || sitio.referencias) && (
            <Card icon={MapPin} title="Domicilio y acceso" testId="v3-ctx-domicilio">
              {(sitio.direccion || sitio.ciudad) && <p className="text-sm text-slate-600 dark:text-slate-300">{[sitio.direccion, sitio.ciudad].filter(Boolean).join(", ")}</p>}
              {sitio.referencias && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{sitio.referencias}</p>}
            </Card>
          )}
          <Card icon={ShieldCheck} title="Cobertura de protección" testId="v3-ctx-cobertura">
            {a._cobertura_sensor ? (
              <p className="text-sm text-slate-600 dark:text-slate-300">{a._cobertura_sensor}</p>
            ) : (
              <p className="text-sm text-slate-500 dark:text-slate-400">Sin incidencias de cobertura reportadas para esta habitación.</p>
            )}
          </Card>
        </>
      )}
    </div>
  );
}
